import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/startWith'
import 'rxjs/add/operator/catch'


import * as api from 'api/playbooks'
import {
  ACTION_TYPES,
  fetchSignatureClickMapSuccess,
  fetchSignatureClickMapPending,
  fetchSignatureClickMapFailed,
} from './actions'

const fetchSignatureClickMap = action$ => (
  action$
    .ofType(ACTION_TYPES.fetchSignatureClickMap)
    .mergeMap((params) => (
      Observable.fromPromise(api.getClickMapData(params))
        .map(({ data }) => fetchSignatureClickMapSuccess(data.clickMapData))
        .startWith(fetchSignatureClickMapPending())
        .catch(() => Observable.of(fetchSignatureClickMapFailed()))
    ))
)


export default combineEpics(
  fetchSignatureClickMap
)
